import { Modal, Checkbox, Button } from "antd";
import jsPDF from "jspdf";
import { useState, useRef, useEffect } from "react";
import moment from "moment";
import { ToWords } from "to-words";

const GenerateInvoice = ({ isOpen, onClose, billingData }) => {
  const [showHeading, setShowHeading] = useState(true);
  const [showPeriod, setShowPeriod] = useState(true);
  const [showItemAmount, setShowItemAmount] = useState(true);
  const [showLogo, setShowLogo] = useState(true);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const pdfPreviewRef = useRef(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const invoiceInfo = billingData?.billingInfo?.salesOrderId;

  console.log("Billing Data is :", invoiceInfo);

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: false,
      ordinal: false,
    },
  });

  const generatePDF = () => {
    const doc = new jsPDF("p", "mm", "a4");

    let startY = 70;
    const columnWidths = [10, 26, 59, 16, 12, 21, 21, 35];
    const rowHeight = 8;
    let headers = [];

    const addHeader = () => {
      // Header Section
      doc.setFont("helvetica", "bold").setFontSize(10);
      doc.text("TAX INVOICE", 10, 25, { maxWidth: 100 });

      doc.setFontSize(8);
      doc.text("(Original for Buyer)", 35, 25);

      doc.setFontSize(14).setFont("helvetica", "bold");
      if (showHeading) {
        doc.text("Yellow Spot OOH", 10, 30, { maxWidth: 100 });
      }
      doc.setFont("helvetica", "normal").setFontSize(10);

      const headerAddress = `12th Block, 4th Floor, Magnet Corporate Park, Opp. Grand Cambay, Thaltej, Ahmedabad-380054.`;
      const headerAddressLines = doc.splitTextToSize(headerAddress, 100);
      doc.text(headerAddressLines, 10, 35);

      const headerAddressHeight = headerAddressLines.length * 5;

      let contentStartY = 30 + headerAddressHeight + 5;

      doc.setFont("helvetica", "bold");
      doc.text("Phone No.: 9033001770", 10, contentStartY);
      contentStartY += 5;
      doc.text(
        "GST No. : 24AADFY0077E1ZE, PAN No. : AADFY0077E",
        10,
        contentStartY
      );
      contentStartY += 5;
      doc.text("MSME No. : UDYAM-GJ-01-0215162", 10, contentStartY);
      doc.setFont("helvetica", "normal");

      if (showLogo) {
        doc.addImage("/images/pptSlide11.png", "PNG", 160, 20, 40, 40);
      }

      let addressLeftY = 70;
      const addressLeftText = [
        "To,",
        invoiceInfo?.bdfId?.brandId?.partyName || "N/A",
        invoiceInfo?.bdfId?.brandId?.partyCompany?.address || "N/A",
        "PAN No. : NA",
      ];

      const wrappedAddressLeftText = doc.splitTextToSize(addressLeftText, 90);
      const lineHeight = 5;
      const addressLeftHeight = wrappedAddressLeftText.length * lineHeight + 10;

      wrappedAddressLeftText.forEach((line, index) => {
        if (index === 1 || index === wrappedAddressLeftText.length - 1) {
          doc.setFont("helvetica", "bold");
        } else {
          doc.setFont("helvetica", "normal");
        }

        const currentYPosition = addressLeftY + index * lineHeight;

        doc.text(line, 15, currentYPosition + 5);
      });

      const addressRightY = addressLeftY;
      const addressRightText = [
        `Bill No. : ${invoiceInfo?.stamp}`,
        `Date : ${moment(billingData?.billingInfo?.createdAt).format(
          "DD-MM-YYYY"
        )}`,
        "Ref. No. : NA",
        "Ref. Date : NA",
        "Place of Supply : NA",
        "Reverse Charge : NA",
      ];
      const addressRightHeight = addressRightText.length * 5 + 10;

      const maxHeight = Math.max(addressLeftHeight, addressRightHeight);

      doc.rect(10, addressLeftY, 95, maxHeight);

      doc.rect(105, addressRightY, 95, maxHeight);

      doc.setFont("helvetica", "bold");
      addressRightText.forEach((line, index) => {
        doc.text(line, 110, addressRightY + 5 + index * 5);
      });
      doc.setFont("helvetica", "normal");

      startY = addressLeftY + maxHeight;

      doc.rect(10, startY, 190, rowHeight);

      doc.line(10, startY, 10, startY + rowHeight);
      doc.line(20, startY, 20, startY + rowHeight);
      doc.line(
        210 - columnWidths[columnWidths.length - 1],
        startY,
        210 - columnWidths[columnWidths.length - 1],
        startY + rowHeight
      );
      doc.line(200, startY, 200, startY + rowHeight);

      headers = ["Sr", "Property", "Media/Location", "Size", "Unit"];
      if (showPeriod) {
        headers.push("From Date", "To Date");
      } else {
        headers.push("", "");
      }
      if (showItemAmount) {
        headers.push("Amount");
      }

      doc.setFont("helvetica", "bold");

      headers.forEach((header, i) => {
        doc.text(
          header,
          12 + columnWidths.slice(0, i).reduce((a, b) => a + b, 0),
          startY + 5
        );
      });

      doc.setFont("helvetica", "normal");

      startY += rowHeight;
    };

    addHeader();

    const rows = [];
    const billableInventories = (invoiceInfo?.bdfId?.inventories || []).filter(
      (inventory) => !inventory?.lineType && inventory?.invId,
    );

    rows.push([
      "",
      `Being the charges for Advertisement through display your ad on Outdoor Hoarding sites at ${invoiceInfo?.bdfId?.brandId?.partyName}`,
      "",
      "",
      "",
      "",
      "",
      "",
    ]);

    rows.push(
      ...billableInventories.map((inventory, index) => [
        `${index + 1}`,
        inventory.invId?.CodeNo || "NA",
        inventory.invId?.locations?.name || "NA",
        `${inventory.invId.width} x ${inventory.invId.height}` || "NA",
        inventory.invId?.unit || "NA",
        moment(inventory.startDate).format("DD-MM-YYYY"),
        moment(inventory.endDate).format("DD-MM-YYYY"),
        inventory?.specialRate?.toFixed(2) || "0.00",
      ]),
    );

    rows.push([
      `${rows.length}`,
      "Production Cost",
      "Printing & Mounting Charges",
      "",
      "",
      "",
      "",
      (invoiceInfo?.printingCharge + invoiceInfo?.mountingCharge).toFixed(2) ||
        "0.00",
    ]);

    // rows.push(
    //   ...Array(10).fill([
    //     "",
    //     "test",
    //     "test test test test test test test test test test test test test",
    //     "9",
    //     "9",
    //     "9",
    //     "9",
    //     "9",
    //   ])
    // );

    if (rows.length <= 4) {
      rows.push(...Array(2).fill(["", "", "", "", "", "", "", ""]));
    }

    const totalSpecialRate = billableInventories.reduce(
      (sum, inventory) => sum + (inventory?.specialRate || 0),
      0
    );

    const total =
      totalSpecialRate +
      (invoiceInfo?.printingCharge || 0) +
      (invoiceInfo?.mountingCharge || 0);

    const totalFormatted = total.toFixed(2);

    const totalAmount = parseFloat(totalFormatted);

    const sgstAmount = (totalAmount * (invoiceInfo?.SGST || 0)) / 100;
    const cgstAmount = (totalAmount * (invoiceInfo?.CGST || 0)) / 100;
    const igstAmount = (totalAmount * (invoiceInfo?.IGST || 0)) / 100;
    const agencyCommAmount =
      (totalAmount * (invoiceInfo?.agencyCommission || 0)) / 100;
    const municipalTaxAmount =
      (totalAmount * (invoiceInfo?.municipalTax || 0)) / 100;
    const otherTaxAmount = (totalAmount * (invoiceInfo?.otherTaxes || 0)) / 100;
    const roundTaxAmount = (totalAmount * (invoiceInfo?.round || 0)) / 100;

    const sgstAmountFormatted = sgstAmount.toFixed(2);
    const cgstAmountFormatted = cgstAmount.toFixed(2);
    const igstAmountFormatted = igstAmount.toFixed(2);
    const agencyCommAmountFormatted = agencyCommAmount.toFixed(2);
    const municipalTaxAmountFormatted = municipalTaxAmount.toFixed(2);
    const otherTaxesAmountFormatted = otherTaxAmount.toFixed(2);
    const roundAmountFormatted = roundTaxAmount.toFixed(2);

    doc.setFontSize(9);

    let newSectionY;
    let newSectionHeight;

    const maxRowsPerPage = 5;
    let rowCount = 0;

    rows.forEach((row, rowIndex) => {
      if (rowCount >= maxRowsPerPage) {
        addSummarySection(false);
        addFooter();

        doc.addPage();
        addHeader();
        startY = startY || 70;
        rowCount = 0;
      }

      let currentX = 10;

      let rowTotalHeight = rowHeight;

      row.forEach((text, index) => {
        if (rowIndex === 0) {
          const staticTextWidth = 150;

          const wrappedText =
            doc.getTextWidth(text) > staticTextWidth
              ? doc.splitTextToSize(text, staticTextWidth)
              : [text];

          rowTotalHeight = Math.max(rowTotalHeight, wrappedText.length * 5);
          const textY =
            startY + rowTotalHeight / 2 - (wrappedText.length * 5) / 2 + 3;

          wrappedText.forEach((line, lineIndex) => {
            doc.text(line, currentX + 2, textY + lineIndex * 5 + 2);
          });

          currentX += columnWidths[index];
          return;
        }

        if (!showPeriod && (index === 5 || index === 6)) {
          currentX += columnWidths[index];
          return;
        }

        if (!showItemAmount && index === row.length - 1) {
          currentX += columnWidths[index];
          return;
        }

        const wrappedText = doc.splitTextToSize(text, columnWidths[index] - 3);
        rowTotalHeight = Math.max(rowTotalHeight, wrappedText.length * 5);

        const textY =
          startY + rowTotalHeight / 2 - (wrappedText.length * 5) / 2 + 3;

        wrappedText.forEach((line, lineIndex) => {
          doc.text(line, currentX + 2, textY + lineIndex * 5 + 2);
        });

        currentX += columnWidths[index];
      });

      doc.line(
        10 + columnWidths[0],
        startY,
        10 + columnWidths[0],
        startY + rowTotalHeight + 2
      );

      doc.line(
        currentX - columnWidths[columnWidths.length - 1],
        startY,
        currentX - columnWidths[columnWidths.length - 1],
        startY + rowTotalHeight + 2
      );

      doc.line(200, startY, 200, startY + rowTotalHeight + 2);

      doc.line(10, startY, 10, startY + rowTotalHeight + 2);

      startY += rowTotalHeight + 2;
      rowCount++;
    });

    doc.setFontSize(10);

    doc.line(10, startY, 200, startY);

    addSummarySection(true);

    function addSummarySection(isLastPage = false) {
      const firstSectionY = startY;
      const firstSectionHeight = isLastPage ? 50 : 30;
      doc.rect(10, firstSectionY, 95, firstSectionHeight);

      if (isLastPage) {
        doc.setFont("helvetica", "bold");
        doc.text("PAN No. : NA", 15, firstSectionY + 10);
        doc.text("HSN/SAC : NA", 15, firstSectionY + 15);
        doc.text("GST Category : NA", 15, firstSectionY + 20);
        doc.setFont("helvetica", "normal");
      }

      const secondSectionY = firstSectionY;

      const maxHeight2 = firstSectionHeight;

      const secondSectionX = 105;
      doc.rect(secondSectionX, secondSectionY, 70, maxHeight2);

      if (isLastPage) {
        doc.text("Total", secondSectionX + 5, secondSectionY + 5);
        doc.text(
          `SGST : ${invoiceInfo?.SGST} %`,
          secondSectionX + 5,
          secondSectionY + 10
        );
        doc.text(
          `CGST : ${invoiceInfo?.CGST} %`,
          secondSectionX + 5,
          secondSectionY + 15
        );
        doc.text(
          `IGST : ${invoiceInfo?.IGST} %`,
          secondSectionX + 5,
          secondSectionY + 20
        );
        doc.text(
          `Agency Comm : ${invoiceInfo?.agencyCommission} %`,
          secondSectionX + 5,
          secondSectionY + 25
        );
        doc.text(
          `Municipal Tax : ${invoiceInfo?.municipalTax} %`,
          secondSectionX + 5,
          secondSectionY + 30
        );
        doc.text(
          `Others : ${invoiceInfo?.otherTaxes} %`,
          secondSectionX + 5,
          secondSectionY + 35
        );
        doc.text(
          `+Round : ${invoiceInfo?.round} %`,
          secondSectionX + 5,
          secondSectionY + 40
        );
      }

      const thirdSectionX = 175;
      doc.rect(thirdSectionX, secondSectionY, 25, maxHeight2);

      if (isLastPage) {
        doc.text(totalFormatted, thirdSectionX + 5, secondSectionY + 5);
        doc.text(sgstAmountFormatted, thirdSectionX + 5, secondSectionY + 10);
        doc.text(cgstAmountFormatted, thirdSectionX + 5, secondSectionY + 15);
        doc.text(igstAmountFormatted, thirdSectionX + 5, secondSectionY + 20);
        doc.text(
          agencyCommAmountFormatted,
          thirdSectionX + 5,
          secondSectionY + 25
        );
        doc.text(
          municipalTaxAmountFormatted,
          thirdSectionX + 5,
          secondSectionY + 30
        );
        doc.text(
          otherTaxesAmountFormatted,
          thirdSectionX + 5,
          secondSectionY + 35
        );
        doc.text(roundAmountFormatted, thirdSectionX + 5, secondSectionY + 40);
      }

      if (isLastPage) {
        doc.line(
          secondSectionX,
          secondSectionY + 42,
          secondSectionX + 70,
          secondSectionY + 42
        );
        doc.line(
          thirdSectionX,
          secondSectionY + 42,
          thirdSectionX + 25,
          secondSectionY + 42
        );
      } else {
        doc.line(
          secondSectionX,
          secondSectionY + 22,
          secondSectionX + 70,
          secondSectionY + 22
        );
        doc.line(
          thirdSectionX,
          secondSectionY + 22,
          thirdSectionX + 25,
          secondSectionY + 22
        );
      }

      const grandTotal =
        parseFloat(totalFormatted) +
        parseFloat(sgstAmountFormatted) +
        parseFloat(cgstAmountFormatted) +
        parseFloat(igstAmountFormatted) +
        parseFloat(agencyCommAmountFormatted) +
        parseFloat(municipalTaxAmountFormatted) +
        parseFloat(otherTaxesAmountFormatted) +
        parseFloat(roundAmountFormatted);

      const formattedGrandTotal = grandTotal.toFixed(2);

      doc.setFont("helvetica", "bold");
      if (isLastPage) {
        doc.text("Grand Total", secondSectionX + 5, secondSectionY + 47);
        doc.text(formattedGrandTotal, thirdSectionX + 5, secondSectionY + 47);
      }
      doc.setFont("helvetica", "normal");

      const grandTotalInWords = toWords
        .convert(formattedGrandTotal)
        .toUpperCase();

      newSectionY = secondSectionY + maxHeight2;
      newSectionHeight = 10;
      doc.rect(10, newSectionY, 190, newSectionHeight);

      if (isLastPage) {
        doc.text("Rupees", 15, newSectionY + 7);
        doc.text(grandTotalInWords + " ONLY", 35, newSectionY + 7);
      }

      doc.line(
        10,
        newSectionY + newSectionHeight,
        200,
        newSectionY + newSectionHeight
      );
    }

    function addFooter() {
      const finalSectionY = newSectionY + newSectionHeight;

      doc.setFont("helvetica", "bold").setFontSize(10);
      doc.text("Terms & Conditions:", 15, finalSectionY + 5);

      const termsText = [
        "1. Cheque & NEFT/RTGS Should be in favour of 'Yellow Spot OOH'.",
        "2. Please do not Deduct TDS On GST.",
        "3. Payment Immediately after issuing this bill.",
        "4. Interest at 18% per annum will be charged on overdue accounts from the date of this bill.",
        "5. Subject to Ahmedabad Jurisdiction.",
        "6. Once ordered should not be cancelled.",
      ];

      doc.setFont("helvetica", "normal").setFontSize(8);
      const lineSpacing = 2.8;
      const pointSpacing = 1;

      let currentY = finalSectionY + 10;
      termsText.forEach((text, index) => {
        const wrappedText = doc.splitTextToSize(text, 100);

        wrappedText.forEach((line, lineIndex) => {
          doc.text(line, 15, currentY);
          currentY += lineSpacing;
        });

        currentY += pointSpacing;
      });

      const bankDetailsY = currentY + 5;
      doc
        .setFont("helvetica", "bold")
        .text("BANK DETAILS : NA", 15, bankDetailsY);
      doc
        .setFont("helvetica", "bold")
        .text("A/C NO. NA, IFSC CODE: NA", 15, bankDetailsY + 5);

      const leftSectionHeight = bankDetailsY - finalSectionY + 10;

      doc.rect(10, finalSectionY, 115, leftSectionHeight);

      doc.rect(125, finalSectionY, 75, leftSectionHeight);
      doc
        .setFont("helvetica", "bold")
        .text("For, Yellow Spot OOH", 150, finalSectionY + 8);
      doc
        .setFont("helvetica", "bold")
        .text("[Authorised Signatory]", 150, bankDetailsY + 5);
      doc.addImage(
        "/images/yellowspotStamp.png",
        "PNG",
        150,
        finalSectionY + 10,
        30,
        30
      );
    }

    addFooter();

    return doc;
  };

  const handleGeneratePDF = () => {
    const doc = generatePDF();
    doc.save("invoice.pdf");
  };

  const handlePreview = () => {
    const doc = generatePDF();
    const pdfBlob = doc.output("blob");

    if (pdfBlob) {
      const pdfUrl = URL.createObjectURL(pdfBlob);

      setPdfUrl(pdfUrl);
      setIsPreviewOpen(true);
    } else {
      console.error("Failed to generate PDF Blob.");
    }
  };

  useEffect(() => {
    if (isPreviewOpen && pdfUrl && pdfPreviewRef.current) {
      pdfPreviewRef.current.src = pdfUrl;
    }
  }, [isPreviewOpen, pdfUrl]);

  return (
    <>
      <Modal
        title={<div style={{ marginBottom: "2rem" }}>Invoice Filters</div>}
        open={isOpen}
        onCancel={onClose}
        footer={[
          <Button key="pdf" type="primary" onClick={handleGeneratePDF}>
            PDF
          </Button>,
          <Button key="preview" type="primary" onClick={handlePreview}>
            Preview
          </Button>,
        ]}
      >
        <div>
          <Checkbox
            checked={showHeading}
            onChange={(e) => setShowHeading(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Print Company Heading
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showPeriod}
            onChange={(e) => setShowPeriod(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Print Period in Bill
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showItemAmount}
            onChange={(e) => setShowItemAmount(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Print Item Amount in Bill / Detail Billing
          </Checkbox>
        </div>
        <div>
          <Checkbox
            checked={showLogo}
            onChange={(e) => setShowLogo(e.target.checked)}
            style={{ marginBottom: "10px" }}
          >
            Logo
          </Checkbox>
        </div>
      </Modal>

      <Modal
        title="Invoice Preview"
        open={isPreviewOpen}
        onCancel={() => setIsPreviewOpen(false)}
        footer={null}
        width="fit-content"
        centered
      >
        {isPreviewOpen && (
          <iframe
            ref={pdfPreviewRef}
            style={{
              width: "310mm", // A4 width
              height: "197mm", // A4 height
              border: "none",
              margin: "0 auto",
              display: "block",
              boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default GenerateInvoice;
